module.exports = __webpack_public_path__ + "static/media/logo.23f8a41f.png";